module.exports = __webpack_public_path__ + "img/32_21.552c843d.png";